// eslint-disable-next-line import-x/no-named-as-default
import DS from 'ember-data';
import { type Registry as Services, service } from '@ember/service';
import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

type QueryResult = DS.PromiseArray<ModelRegistry['messaging-channel']>;

export default class MessagingChannelRepositoryService extends BaseRepositoryService<
  ModelRegistry['messaging-channel']
> {
  @service session!: Services['session'];

  recordName = 'messaging-channel';
  implementMethods = ['query'];

  public async query(query: object, options?: object): Promise<QueryResult> {
    if (!this.session.currentUser?.hasAccessTo('bookings.messages')) {
      return [] as unknown as QueryResult;
    }

    return super.query(query, options);
  }
}

declare module '@ember/service' {
  interface Registry {
    'repositories/messaging-channel': MessagingChannelRepositoryService;
  }
}
